import script from "./PhotoPackageList.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoPackageList.vue?vue&type=script&setup=true&lang=js"

import "./PhotoPackageList.vue?vue&type=style&index=0&id=e04ffa70&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e04ffa70"]])

export default __exports__